import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { TextField, Checkbox, Grid, Button, Paper, Menu, Typography, InputLabel, OutlinedInput, Select, FormControl, Radio, FormControlLabel } from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as Actions from './store/actions';
import MenuItem from '@material-ui/core/MenuItem';
import ArrayItemSearch from './ArrayItemSearch';
import _ from 'lodash';

const styles = theme => ({
    filterColumn: {
        margin: '10px'
    }
});

class TableFilter extends Component {

    constructor(props) {
        super(props);
        this.props.initializeFilters(props.defaultList, props.componentName, props.columns)
    }

    handleChange = field_name => event => {
        const value = event.target.value
        return this.props.updateFilterColumn(field_name, value)
    }

    getColumnInputField = (column) => {
        switch (column.columnType) {
            case ('string'):
                {
                    return (
                        <Grid item xs={12} className={this.props.classes.filterColumn}>
                            <TextField
                                style={{ minWidth: '250px', }}
                                variant={'outlined'}
                                id={column.column_id}
                                label={column.columnName}
                                value={column.value}
                                onChange={this.handleChange(column.column_id)}
                            />
                        </Grid>
                    )
                }
            case ('binary_switch'):
                {
                    return (
                        <Grid item xs={12} className={this.props.classes.filterColumn}>
                            <Typography component="div" variant={'h6'}>{column.columnName}</Typography>
                            <FormControl variant="outlined">
                                <Grid container spacing={0}>
                                    <Grid item xs={4}>
                                        <FormControlLabel
                                            value="start"
                                            control={
                                                <Radio
                                                    checked={Number(column.value) === 0}
                                                    onChange={this.handleChange(column.column_id)}
                                                    value={0}
                                                    name="radio-button-demo"
                                                    inputProps={{ 'aria-label': 'B' }}
                                                />
                                            }
                                            label="Off"
                                            labelPlacement="end"
                                        />
                                    </Grid>

                                    <Grid item xs={4}>
                                        <FormControlLabel
                                            value="start"
                                            control={
                                                <Radio
                                                    checked={Number(column.value) === 1}
                                                    onChange={this.handleChange(column.column_id)}
                                                    value={1}
                                                    name="radio-button-demo"
                                                    inputProps={{ 'aria-label': 'B' }}
                                                />
                                            }
                                            label="No"
                                            labelPlacement="end"
                                        />
                                    </Grid>

                                    <Grid item xs={4}>
                                        <FormControlLabel
                                            value="start"
                                            control={
                                                <Radio
                                                    checked={Number(column.value) === 2}
                                                    onChange={this.handleChange(column.column_id)}
                                                    value={2}
                                                    name="radio-button-demo"
                                                    inputProps={{ 'aria-label': 'B' }}
                                                />
                                            }
                                            label="Yes"
                                            labelPlacement="end"
                                        />
                                    </Grid>
                                </Grid>
                            </FormControl>
                        </Grid>
                    )
                }
            case ('array'):
                {
                    return (
                        <Grid item xs={12} className={this.props.classes.filterColumn}>
                            <ArrayItemSearch
                                options={column.searchableValues}
                                column_id={column.column_id}
                                columnName={column.columnName}
                                switchVal={column.switchVal}
                                selected={column.value}
                            />
                        </Grid>
                    )
                }
            default: null
        }
    }

    render() {
        const { tableFilter } = this.props
        return (
            <Grid item xs={12}>
                {tableFilter.filterColumns.map(col => {
                    return (
                        <React.Fragment key={col.column_id}>
                            {this.getColumnInputField(col)}
                        </React.Fragment>

                    )
                })}
            </Grid>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updateFilterColumn: Actions.updateFilterColumn,
        initializeFilters: Actions.initializeFilters,
    }, dispatch);
}

function mapStateToProps({ auth, tableFilter, tableSort }) {
    return {
        tableFilter: tableFilter,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(TableFilter)));



// WEBPACK FOOTER //
// src/main/components/tableFilter/TableFilter.js